import { MovieStreamMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { Subtitles } from '@/scenarios/legacy-player/types/config';

export const transformSubtitles: (
    subtitles: MovieStreamMetaFragment['subtitleMetas'] | undefined
) => Subtitles[] = (subtitles) => {
    if (!subtitles) {
        return [];
    }

    return subtitles.map((meta) => ({
        label: meta?.title ?? '',
        language: meta?.language ?? '',
        url: meta?.url ?? '',
    }));
};
